export default __webpack_public_path__ + "static/media/YMCA-7-1-04-004.6d15a24a.jpg";